import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import servicesUtils from "./servicesUtils";
function getURL(workspaceId) {
  var URL = "/workspaces/" + workspaceId;
  return function (suffix) {
    return URL + "/site/" + suffix;
  };
}
function approveMachines(workspaceId, listOfSelectedIds) {
  var MACHINES_URL = getURL(workspaceId)("machines");
  var promises = listOfSelectedIds.map(function (id) {
    var MACHINES_URL_WITH_ID = MACHINES_URL + "/" + id + "/approve/";
    return servicesUtils.postService(MACHINES_URL_WITH_ID, {
      approved: "APPROVED"
    });
  });
  return Promise.allSettled(promises);
}
function revokeMachines(workspaceId, listOfSelectedIds) {
  var MACHINES_URL = getURL(workspaceId)("machines");
  var promises = listOfSelectedIds.map(function (id) {
    var MACHINES_URL_WITH_ID = MACHINES_URL + "/" + id + "/approve/";
    return servicesUtils.postService(MACHINES_URL_WITH_ID, {
      approved: "REJECTED"
    });
  });
  return Promise.allSettled(promises);
}
function approveUsers(workspaceId, listOfSelectedIds) {
  var USERS_URL = getURL(workspaceId)("users");
  var promises = listOfSelectedIds.map(function (id) {
    var USERS_URL_WITH_ID = USERS_URL + "/" + id + "/approve/";
    return servicesUtils.postService(USERS_URL_WITH_ID, {
      approved: "APPROVED"
    });
  });
  return Promise.allSettled(promises);
}
function revokeUsers(workspaceId, listOfSelectedIds) {
  var USERS_URL = getURL(workspaceId)("users");
  var promises = listOfSelectedIds.map(function (id) {
    var USERS_URL_WITH_ID = USERS_URL + "/" + id + "/approve/";
    return servicesUtils.postService(USERS_URL_WITH_ID, {
      approved: "REJECTED"
    });
  });
  return Promise.allSettled(promises);
}
function getMachinesAndUsers(workspaceId) {
  var USERS_URL = getURL(workspaceId)("users");
  var promiseFetchingUsers = servicesUtils.getService(USERS_URL);
  var MACHINES_URL = getURL(workspaceId)("machines");
  var promiseFetchingMachines = servicesUtils.getService(MACHINES_URL);
  return Promise.allSettled([promiseFetchingUsers, promiseFetchingMachines]);
}
function paginationCore(state) {}
function hasNextPage(state) {
  var totalLength = state.data[state.view].length;
  var _state$viewData = state.viewData,
    maxRowsPerPage = _state$viewData.maxRowsPerPage,
    currentPage = _state$viewData.currentPage;
  var nextPageStartingIdx = currentPage * maxRowsPerPage + 1;
  var hasNextPage = nextPageStartingIdx <= totalLength;
  return hasNextPage;
}
function hasPrevPage(state) {
  var totalLength = state.data[state.view].length;
  var _state$viewData2 = state.viewData,
    maxRowsPerPage = _state$viewData2.maxRowsPerPage,
    currentPage = _state$viewData2.currentPage;
  var prevPageStartingIdx = (currentPage - 1) * maxRowsPerPage;
  var hasPrevPage = currentPage > 1 && prevPageStartingIdx <= totalLength;
  return hasPrevPage;
}
function getValidApproveCount(state) {
  var _state$data;
  var obj = {
    approve: 0,
    revoke: 0
  };
  if (!state.data) {
    return obj;
  }
  var newObj = (_state$data = state.data) === null || _state$data === void 0 ? void 0 : _state$data[state.view].filter(function (x) {
    return state.viewData.selectedRows.includes(x.id);
  }).reduce(function (currentObj, item) {
    var validApproveStates = ["PENDING", "REJECTED"];
    var validRevokeStates = ["PENDING", "REJECTED", "APPROVED"];
    if (validApproveStates.includes(item.approved)) {
      currentObj.approve += 1;
    } else if (validRevokeStates.includes(item.approved)) {
      currentObj.revoke += 1;
    }
    return _objectSpread({}, currentObj);
  }, obj);
  return newObj;
}
export { approveMachines, revokeMachines, approveUsers, revokeUsers, getMachinesAndUsers, hasNextPage, hasPrevPage, getValidApproveCount };